import { createMuiTheme } from '@material-ui/core/styles';
import orange from '@material-ui/core/colors/orange';
import deepOrange from '@material-ui/core/colors/deepOrange';
import grey from '@material-ui/core/colors/grey';

const white = '#fff';

const theme = createMuiTheme({
  palette: {
    primary: { main: orange[400] },
    secondary: { main: deepOrange[400] },
    text: {
      primary: grey[800],
      secondary: white,
    },
    background: { main: grey[100] },
    cardBackground: white,
    borderColor: grey[500],
  },
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: white,
      },
    },
    MuiInputLabel: {
      formControl: {
        color: grey[400],
      },
      shrink: {
        color: grey[400],
      },
      outlined: {
        color: grey[400],
      },
    },
    MuiTableCell: {
      head: {
        color: grey[400],
      },
    },
    MuiRadio: {
      colorPrimary: {
        color: grey[400],
      },
    },
    MuiList: {
      root: {
        backgroundColor: white,
      },
    },
    MuiTypography: {
      subtitle2: {
        color: white,
      },
    },
  },
});

export default theme;
